import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'semantic-ui-react';

const imgStyle = { margin: '0px auto' };
const width100 = { width: '100%' };

const instagramStyle = {
  height: '300px',
  minHeight: '300px',
  width: '300px',
  objectFit: 'cover',
  display: 'block',
  margin: '0px auto',
};

const brandMentionStyle = {
  height: '150px',
  minHeight: '150px',
  width: '150px',
  objectFit: 'cover',
  display: 'block',
  margin: '0px auto',
};

const getStyle = (useInstagramStyle, maxWidth, brandMention) => {
  if (brandMention) return brandMentionStyle;
  if (useInstagramStyle) return instagramStyle;
  if (maxWidth) return width100;
  return imgStyle;
};

const DyzioInstagramEmbed = props => {
  const { maxWidth, useInstagramStyle, brandMention, assetId, imageUrl } = props;

  const derivedStyle = getStyle(useInstagramStyle, maxWidth, brandMention);
  const imgSrc = imageUrl || `https://img.dyzio.co/image/${assetId}/size/m`;
  return (
    <Image
      size="large"
      style={derivedStyle}
      src={imgSrc}
    />
  );
};

DyzioInstagramEmbed.propTypes = {
  assetId: PropTypes.string.isRequired,
  useInstagramStyle: PropTypes.string,
  maxWidth: PropTypes.string,
  brandMention: PropTypes.bool,
  imageUrl: PropTypes.string,
};

DyzioInstagramEmbed.defaultProps = {
  maxWidth: false,
  useInstagramStyle: false,
  brandMention: false,
};

export default DyzioInstagramEmbed;



/** WEBPACK FOOTER **
 ** ./src/components/dyzio-instagram-embed2/index.js
 **/